{
  "name": "@qima/my-backoffice",
  "version": "1.166.0",
  "description": "QIMA backoffice for new service types (orders, records, and workflows outside legacy Inspections, Audits, Certificate, and Lab Testing)",
  "private": false,
  "license": "UNLICENSED",
  "engines": {
    "node": "22.12.0",
    "npm": "10.9.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/asiainspection/my-backoffice.git"
  },
  "bugs": {
    "url": "https://github.com/asiainspection/my-backoffice/issues"
  },
  "homepage": "https://github.com/asiainspection/my-backoffice#readme",
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-customizable"
    },
    "cz-customizable": {
      "config": "./tools/commitizen.js"
    }
  },
  "contributors": [
    {
      "email": "jamine.wu@qima.com",
      "name": "Jamine Wu",
      "url": "https://github.com/JamieWuJinYi"
    }
  ],
  "keywords": [
    "ui",
    "framework",
    "frontend",
    "angular",
    "my-backoffice",
    "nx"
  ],
  "scripts": {
    "ng": "nx",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "start:my-backoffice:dev": "nx serve --configuration=dev-local --live-reload=true",
    "start:my-backoffice:pp": "nx serve --configuration=pp-local --live-reload=true",
    "start:my-backoffice:staging": "nx serve --configuration=staging-local --live-reload=true",
    "start:my-backoffice:prod": "nx serve --configuration=prod-local --live-reload=true",
    "test:all": "nx run-many --target=test --all",
    "test:my-backoffice": "npm run run-jest -- --config apps/jest.config.js --logHeapUsage --selectProjects my-backoffice",
    "test:my-backoffice:coverage": "npm run run-jest -- --config apps/jest.config.js --coverage --logHeapUsage --selectProjects my-backoffice",
    "build:all": "nx run-many --target=build --all",
    "build:my-backoffice": "cross-env NODE_OPTIONS=--max_old_space_size=4096 nx build my-backoffice --configuration=production",
    "build:my-backoffice:dev": "cross-env NODE_OPTIONS=--max_old_space_size=4096 nx build my-backoffice --configuration=dev",
    "build:my-backoffice:pp": "cross-env NODE_OPTIONS=--max_old_space_size=4096 nx build my-backoffice --configuration=pp",
    "build:my-backoffice:staging": "cross-env NODE_OPTIONS=--max_old_space_size=4096 nx build my-backoffice --configuration=staging",
    "lint:all": "npm run concurrently -- \"npm:lint:all:code\" \"npm:lint:all:other\" \"npm:lint:all:style\" --prefix-colors green,cyan,magenta",
    "lint:all:code": "nx affected:lint --all",
    "lint:all:code:hook": "nx affected:lint --files",
    "lint:all:other": "nx format:write --all",
    "lint:all:other:hook": "nx format:write --files",
    "lint:all:style": "npm run stylelint -- \"**/*.{css,scss}\" --cache --fix --quiet",
    "lint:all:style:hook": "npm run stylelint -- --cache --fix --quiet",
    "lint:all:style:ci": "npm run stylelint -- \"**/*.{css,scss}\" --cache --quiet",
    "lint:affected:style": "bash -c 'base=${NX_BASE:-origin/develop}; head=${NX_HEAD:-HEAD}; files=$(git diff --name-only --diff-filter=ACMRT \"$base\" \"$head\" 2>/dev/null | grep -E \"\\.(css|scss)$\" || true); if [ -n \"$files\" ]; then echo \"$files\" | xargs npm run stylelint -- --cache --quiet; else echo \"No changed style files to lint\"; fi'",
    "lint:stylelint-config-prettier-check": "stylelint-config-prettier-check",
    "g:c:my-backoffice": "nx generate @nx/angular:component $npm_config_name --changeDetection=OnPush --project=my-backoffice --skipTests=true",
    "g:s:my-backoffice": "nx generate @nx/angular:service $npm_config_name --project=my-backoffice",
    "stylelint": "stylelint --config-basedir node_modules --color --custom-syntax postcss-scss",
    "update": "nx migrate latest",
    "workspace-generator": "nx workspace-generator",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "cz": "git add . && git-cz && npm run git:push",
    "prepare": "husky install",
    "pre-commit": "lint-staged --relative",
    "commit-msg": "cross-env LOGGING_LEVEL=debug cz-customizable-ghooks",
    "post-commit": "git update-index --again",
    "concurrently": "cross-env NODE_OPTIONS=--max_old_space_size=3500 concurrently --kill-others-on-fail --prefix \"[{name}][{time}]\" --timestamp-format \"HH:mm:ss\"",
    "install-git-hooks": "husky install && shx rm -rf .git/hooks && shx ln -s ../.husky .git/hooks",
    "verify-policy": "node ./tools/verify-policy.js",
    "create-release": "semantic-release",
    "after-release": "node tools/after-release.js",
    "copy:changelog-to-dist": "shx cp CHANGELOG.md dist/apps",
    "aws-sso-login": "aws sso login --profile qima-prod",
    "artifact-registry-login": "aws codeartifact login --tool npm --domain qima --profile qima-prod --region ap-southeast-1 --namespace @qima --repository qima-npm",
    "run-jest": "cross-env NODE_OPTIONS=--max_old_space_size=15000 npx --package jest@30 --yes jest"
  },
  "dependencies": {
    "@adyen/adyen-web": "^6.5.0",
    "@angular/animations": "21.2.9",
    "@angular/cdk": "21.2.9",
    "@angular/cdk-experimental": "21.2.9",
    "@angular/common": "21.2.9",
    "@angular/compiler": "21.2.9",
    "@angular/core": "21.2.9",
    "@angular/forms": "21.2.9",
    "@angular/localize": "21.2.9",
    "@angular/platform-browser": "21.2.9",
    "@angular/platform-browser-dynamic": "21.2.9",
    "@angular/pwa": "21.2.9",
    "@angular/router": "21.2.9",
    "@angular/service-worker": "21.2.9",
    "@ngneat/reactive-forms": "5.0.2",
    "@ngneat/until-destroy": "9.2.3",
    "@ngx-translate/core": "15.0.0",
    "@ngx-translate/http-loader": "8.0.0",
    "@paypal/paypal-js": "9.2.0",
    "@qima/ngx-qima": "21.0.2",
    "@qima/qsp-ui-library": "1.0.33",
    "@types/lodash": "^4.17.20",
    "angular-svg-icon": "19.1.1",
    "autolinker": "4.0.0",
    "clipboard": "^2.0.11",
    "country-flags-svg": "1.1.9",
    "crypto-js": "4.2.0",
    "dayjs": "1.11.9",
    "hammerjs": "2.0.8",
    "http-server": "14.1.1",
    "http-status-codes": "2.3.0",
    "libphonenumber-js": "1.11.17",
    "localforage": "1.10.0",
    "lodash": "^4.17.21",
    "lodash-es": "4.17.21",
    "logrocket": "3.0.1",
    "moment-timezone": "0.5.45",
    "ngx-cookie": "6.0.1",
    "rxjs": "7.8.2",
    "simple-xml-to-json": "1.2.2",
    "ts-md5": "1.3.1",
    "tslib": "2.5.3",
    "ua-parser-js": "^1.0.39",
    "uuid": "10.0.0",
    "viewerjs": "1.11.7",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/architect": "0.2102.9",
    "@angular-devkit/build-angular": "21.2.9",
    "@angular-devkit/schematics": "21.2.9",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular/cli": "21.2.9",
    "@angular/compiler-cli": "21.2.9",
    "@eslint/eslintrc": "3.3.1",
    "@eslint/js": "9.28.0",
    "@jest/test-sequencer": "30.4.1",
    "@ngneat/spectator": "21.0.1",
    "@nx/angular": "22.7.6",
    "@nx/eslint": "22.7.6",
    "@nx/eslint-plugin": "22.7.6",
    "@nx/jest": "22.7.6",
    "@nx/rollup": "22.7.6",
    "@nx/workspace": "22.7.6",
    "@rollup/plugin-terser": "0.4.4",
    "@rxlint/eslint-plugin-angular": "1.2.13",
    "@schematics/angular": "21.2.9",
    "@semantic-release/changelog": "6.0.3",
    "@semantic-release/exec": "6.0.3",
    "@semantic-release/git": "10.0.1",
    "@semantic-release/github": "9.2.6",
    "@semantic-release/npm": "10.0.6",
    "@signal-noise/stylelint-scales": "2.0.3",
    "@smarttools/eslint-plugin-rxjs": "1.0.22",
    "@sonia-corporation/conventional-changelog": "1.3.0",
    "@types/crypto-js": "4.2.2",
    "@types/faker": "5.5.9",
    "@types/fs-extra": "11.0.4",
    "@types/jest": "30.0.0",
    "@types/lodash-es": "4.17.12",
    "@types/node": "18.19.31",
    "@types/tableau": "2.2.8",
    "@types/ua-parser-js": "^0.7.39",
    "@types/uuid": "9.0.8",
    "@typescript-eslint/eslint-plugin": "8.55.0",
    "@typescript-eslint/parser": "8.55.0",
    "app-root-path": "3.1.0",
    "axios": "1.7.4",
    "chalk": "4.1.2",
    "commitizen": "4.3.0",
    "concurrently": "8.2.2",
    "cross-env": "7.0.3",
    "cz-customizable": "7.0.0",
    "cz-customizable-ghooks": "2.0.0",
    "eslint": "9.28.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-config-recommended": "4.1.0",
    "eslint-import-resolver-typescript": "3.6.1",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jest": "28.11.0",
    "eslint-plugin-jsdoc": "48.2.3",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-prettier": "5.5.5",
    "eslint-plugin-progress": "0.0.1",
    "faker": "5.5.3",
    "fs-extra": "11.2.0",
    "globals": "16.2.0",
    "husky": "9.0.11",
    "jest": "30.4.2",
    "jest-environment-jsdom": "30.4.1",
    "jest-extended": "4.0.2",
    "jest-preset-angular": "16.0.0",
    "lint-staged": "15.2.2",
    "ng-packagr": "21.2.5",
    "nx": "22.7.6",
    "nx-cloud": "19.1.0",
    "postcss": "8.4.38",
    "postcss-import": "16.1.0",
    "postcss-preset-env": "9.5.9",
    "postcss-scss": "4.0.9",
    "postcss-url": "10.1.3",
    "prettier": "3.8.1",
    "react-syntax-highlighter": "15.5.0",
    "semantic-release": "20.1.3",
    "shx": "0.3.4",
    "sonarqube-scanner": "^3.3.0",
    "stylelint": "16.6.1",
    "stylelint-config-standard": "36.0.0",
    "stylelint-config-standard-scss": "13.1.0",
    "stylelint-order": "6.0.4",
    "stylelint-prettier": "5.0.0",
    "stylelint-scss": "6.2.1",
    "ts-jest": "29.4.0",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.55.0",
    "webpack": "5.88.0"
  },
  "volta": {
    "node": "22.12.0"
  }
}
